import InvoicesDetailsTableView from './InvoicesDetailsTableView';

export default InvoicesDetailsTableView;
